import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../baseurl";
import axios from "axios";
import { Link } from "react-router-dom";
import { GetIp } from "../ShortCutComponents/Get_ip";
import ResponseLoader from "../ShortCutComponents/ResponseLoader";
import { checkPermission } from "../../../Helper";
import moment from "moment";
import Swal from "sweetalert2";
import { FaLockOpen, FaLock } from "react-icons/fa6";

const MonthCloseGrid = () => {
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");

  const [selectedYear, setSelectedYear] = useState("");
  const [months, setMonths] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMonth, setModalMonth] = useState("");
  const [monthLov, setMonthLov] = useState([]);
  const [yearLov, setYearLov] = useState([]);
  const [loadingResponce, setLoadingResponce] = useState(false);

  const [history, setHistory] = useState({
    July: ["01-Jul-2023 Opened", "15-Jul-2023 Closed"],
    August: ["02-Aug-2023 Opened"],
  });

  useEffect(() => {
    const funCall = async (value) => {
      await asyncRollCheck(value);
    };
    funCall(0);

    getLovs();
    getMonth();
  }, []);

  const getMonth = (save) => {
    setLoadingResponce(true);
    axios
      .post(
        `${baseurl}/lovs/getMonth`,
        {
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        setLoadingResponce(false);
        const responseData = response.data.data;
        if (save) {
          let filteredMonth = filterByDateRange(
            responseData,
            selectedYear.rangeStart,
            selectedYear.rangeEnd
          );
          console.log("filtered", filteredMonth);
          setMonths(filteredMonth);
        }
        setMonthLov(responseData);
      })
      .catch((err) => {
        setLoadingResponce(false);
        console.log(err);
      });
  };
  const asyncRollCheck = async (value) => {
    let pathname = "/monthClosing";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  const getLovs = () => {
    setLoadingResponce(true);
    axios
      .post(
        `${baseurl}/lovs/getFinancialYear`,
        {
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((response) => {
        setLoadingResponce(false);
        const responseData = response.data.data;
        const formattedData = responseData.map((item) => {
          const start = moment(item.rangeStart);
          const end = moment(item.rangeEnd);

          const yearPart = `${start.format("YYYY")} - ${end.format("YYYY")}`;
          const datePart = `( ${start.format("D MMMM YYYY")} to ${end.format(
            "D MMMM YYYY"
          )} )`;

          return {
            ...item,
            label: yearPart + "\u00A0 " + "\u00A0 " + datePart,
          };
        });
        setYearLov(formattedData);
      })
      .catch((err) => {
        setLoadingResponce(false);
        console.log(err);
      });
  };

  const handleYearChange = (value) => {
    setSelectedYear(value);

    console.log("yearString=", value);
    if (value?.id >= 0) {
      let filteredMonth = filterByDateRange(
        monthLov,
        value.rangeStart,
        value.rangeEnd
      );
      console.log("filtered", filteredMonth);
      setMonths(filteredMonth);
    }
  };
  function filterByDateRange(data, rangeStart, rangeEnd) {
    const start = new Date(rangeStart);
    const end = new Date(rangeEnd);

    const filtered = data.filter((item) => {
      const itemDate = new Date(item.date);
      return itemDate >= start && itemDate <= end;
    });
    return filtered;
  }

  const getUserIp = async function () {
    let res = await GetIp();
    console.log(res);
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };
  const handleToggle = (id, Closed_yn, date, index, month) => {
    console.log("index", index, Closed_yn);
    let openCloseCheck = false;
    if (Closed_yn && index > 0) {
      openCloseCheck = months[index - 1].Closed_yn === 1 ? true : false;
    } else if (!Closed_yn && index < 11) {
      openCloseCheck = months[index + 1].Closed_yn === 0 ? true : false;
    }
    if (
      (index === 0 && Closed_yn) ||
      (index === 11 && !Closed_yn) ||
      openCloseCheck
    ) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: `Yes, ${Closed_yn ? "Closed" : "Open"} it!`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoadingResponce(true);

          let { userIp, userCountry } = await getUserIp();
          axios
            .post(
              `${baseurl}/pointOfSale/updateMonth`,
              {
                id,
                date,
                Closed_yn: Closed_yn ? 1 : 0,
                companyId,
                username: username,
                userIp,
                userCountry,
              },
              {
                headers: {
                  authorization: token,
                },
              }
            )

            .then(function (response) {
              getMonth(true);
              setLoadingResponce(false);
              console.log(response.data);
              swal({
                title: "Success!",
                text: `Month is ${Closed_yn ? "Closed" : "Open"}!`,
                icon: "success",
              }).then((value) => {});
            })
            .catch(function (error) {
              console.log(error);
              setLoadingResponce(false);

              swal({
                title: "Error",
                text: "Something went wrong, try to refresh the page and try again.",
                icon: "error",
              });
            });
        }
      });
    } else {
      swal({
        title: `No ${Closed_yn ? "Closed" : "Open"}!`,
        text: `Must be all Months are ${
          Closed_yn ? "Closed before" : "Open after"
        }  ${month}!`,
        icon: "warning",
      });
    }
  };

  const viewHistory = async (id) => {
    setLoadingResponce(true);

    axios
      .post(
        `${baseurl}/pointOfSale/viewMonthHistory`,
        {
          id,
          companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )

      .then(function (response) {
        setLoadingResponce(false);
        console.log(response.data.data);
        setHistory(response.data.data);
        // setModalMonth(month);
        setShowModal(true);
      })
      .catch(function (error) {
        console.log(error);
        setLoadingResponce(false);

        swal({
          title: "Error",
          text: "Something went wrong, try to refresh the page and try again.",
          icon: "error",
        });
      });
  };

  return (
    <>
      {loadingResponce ? (
        <ResponseLoader />
      ) : (
        <div className="container mt-4 mb-4">
          <div className="row align-items-center mb-3">
            <div className="col-auto">
              <i
                className="fa fa-calendar fa-2x text-primary"
                aria-hidden="true"
              ></i>
            </div>

            <div className="col" style={{ marginLeft: "-19px" }}>
              <h3 className="mb-1">Month Closing Management</h3>
              <p className="mb-0 text-muted">
                Manage financial period closures for your organization
              </p>
            </div>

            <div className="col-6">
              <Select
                value={selectedYear}
                onChange={(e) => handleYearChange(e)}
                options={yearLov}
                required
                name="year"
                // isDisabled={disabledState}
                id="year"
                isClearable
                placeholder={"-- Select --"}
              />
            </div>
          </div>

          {/* Grid */}
          {selectedYear?.id >= 0 && (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)", // <<< FIXED (4 columns)
                gap: "15px",
              }}
              className="mt-2"
            >
              {months.map((m, idx) => (
                <div
                  key={m.mon_cl_id}
                  style={{
                    padding: "20px",
                    borderRadius: "10px",
                    background: "#f8f9fa",
                    border: "1px solid #ddd",
                    textAlign: "center",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                    position: "relative",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    transform: "translateY(0)",
                  }}
                  className="month-card"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#ffffff";
                    e.currentTarget.style.boxShadow =
                      "0 5px 15px rgba(0,0,0,0.2)";
                    e.currentTarget.style.borderColor = "#007bff";
                    e.currentTarget.style.transform = "translateY(-5px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#f8f9fa";
                    e.currentTarget.style.boxShadow =
                      "0 2px 5px rgba(0,0,0,0.1)";
                    e.currentTarget.style.borderColor = "#ddd";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                    }}
                  >
                    {!m.Closed_yn ? (
                      <FaLockOpen size={20} className="text-success" />
                    ) : (
                      <FaLock size={20} className="text-danger" />
                    )}
                  </div>

                  <div className="d-flex flex-column align-items-center">
                    <h5 className="mt-2">{m.month_name}</h5>
                    <span>{m.year_no}</span>
                  </div>
                  <Button
                    variant={!m.Closed_yn ? "danger" : "success"}
                    size="sm"
                    onClick={() =>
                      handleToggle(
                        m.mon_cl_id,
                        !m.Closed_yn,
                        m.date,
                        idx,
                        m.month_name
                      )
                    }
                    className="mt-2 mr-2"
                  >
                    {!m.Closed_yn ? "Close" : "Open"}
                  </Button>

                  <Button
                    variant="info"
                    size="sm"
                    onClick={() => {
                      viewHistory(m.mon_cl_id);
                    }}
                    className="mt-2 text-white"
                  >
                    View Log
                  </Button>
                </div>
              ))}
            </div>
          )}

          {/* Modal */}
          <Modal show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>{modalMonth} History</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {history.length ? (
                <ul>
                  {history.map((h, i) => (
                    <li key={i}>{h.formatted_output}</li>
                  ))}
                </ul>
              ) : (
                <p>No history found.</p>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  );
};

export default MonthCloseGrid;
